// Ask the server whether an email address's domain can receive mail
// (backend/routes/emailCheck.js). Fails open: if the check itself can't
// run, the sign-up carries on.
export const checkEmail = async (email) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/email-check?email=${encodeURIComponent(String(email || '').trim())}`);
    if (!res.ok) return { ok: true };
    return await res.json();
  } catch {
    return { ok: true };
  }
};
